export function SicknessSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/sickness.svg'"></ng-include>`
    }
}